import { PROFILE_IMAGE } from "../actionType";

const INIT_STATE = { profileImage: "" };

const profileReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case PROFILE_IMAGE:
      return {
        ...state,
        profileImage: action.profileImage,
      };

    default:
      return state;
  }
};

export default profileReducer;